import script from "./RootNode.vue?vue&type=script&setup=true&lang=js"
export * from "./RootNode.vue?vue&type=script&setup=true&lang=js"

import "./RootNode.vue?vue&type=style&index=0&id=7e193fa6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e193fa6"]])

export default __exports__